import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { compose } from 'redux';
import DropdownWrapper from '../../../../../../common/components/DropdownWrapper/DropdownWrapper';
import * as activityConstants from '../../../../activity.constants';

class SendEmailCustomDropDown extends React.Component {
  static propTypes = {
    options: PropTypes.object,
    onActionFieldUpdate: PropTypes.func.isRequired,
    senderPrefix: PropTypes.string,
    index: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    placeHolder: PropTypes.string,
    allowMultiple: PropTypes.bool.isRequired,
    value: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = {
      additionalOptions: [],
    };
  }

  get parsedOptions() {
    const parsedOptions = [];
    const { options } = this.props;

    options.forEach((option) => {
      const parsedValue = option.replace(this.props.senderPrefix, '');
      parsedOptions.push({ key: option, text: parsedValue, value: parsedValue });
    });

    this.state.additionalOptions.forEach((option) => {
      const exists = parsedOptions.some((parsedOption) => parsedOption.key === option);
      if (!exists) {
        const parsedValue = option.replace(this.props.senderPrefix, '');
        parsedOptions.push({ key: option, text: parsedValue, value: parsedValue });
      }
    });

    return parsedOptions;
  }

  handleEmailCustomSenderNameChange = (event, target) => {
    if (target.value.trim().length !== 0) {
      const emailFromTag = this.props.senderPrefix + target.value;
      this.props.onActionFieldUpdate(activityConstants.ACTION_TAGS, [emailFromTag], this.props.index);
      const newAdditionalOptions = [...this.state.additionalOptions, emailFromTag];
      this.setState({
        additionalOptions: newAdditionalOptions
      });
    }
  }

  render() {
    const options = this.parsedOptions;
    return (
      <React.Fragment>
        <DropdownWrapper
          className="auto-complete-wrapper"
          options={options}
          onSelectOption={(e, target) => this.handleEmailCustomSenderNameChange(e, target)}
          value={this.props.value}
          disabled={false}
          prefix={'customSenderNames'}
          multiple={this.props.allowMultiple}
          search
          allowAdditions
          placeholder={this.props.placeHolder}
          onOpen={this.props.onOpen}
          onClose={this.props.onClose}
        />
      </React.Fragment>
    );
  }
}

export default compose(injectIntl)(SendEmailCustomDropDown);
